import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LandingPage from './LandingPage';
import LogoutButton from './LogoutButton';
import Loading from "./Loading";
import App from "./App";

const Profile = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <Loading/>;
  }

  if (!isAuthenticated) {
    return <LandingPage/>;
  }

  return (
    isAuthenticated && (
        <div style={styles.container}>
        <div style={styles.profileCard}>
          <img src={user.picture} alt={user.name} style={styles.avatar} />
          <h2 style={styles.name}>{user.name}</h2>
          <p style={styles.email}>{user.email}</p>
          <LogoutButton/>
        </div>
        <App/>
      </div> 
    )
  );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f0f4f8",
      minHeight: "100vh",
    },
    profileCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      borderRadius: "12px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#ffffff",
      marginBottom: "20px",
      width: "280px",
      textAlign: "center",
    },
    avatar: {
      width: "80px",
      height: "80px",
      borderRadius: "50%",
      marginBottom: "10px",
      objectFit: "cover",
      border: "3px solid #007bff",
    },
    name: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "5px",
    },
    email: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "15px",
    },
    logoutButton: {
      padding: "8px 15px",
      fontSize: "14px",
      color: "#fff",
      backgroundColor: "#007bff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "0.3s ease",
    },
  };

export default Profile;